import React from "react";
import { IconProps } from "../icon";

export const LockUnlocked_04Icon = ({ size = "24px", color = "#000", ...props }: IconProps<string, string>) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M7 10V8a5 5 0 019-3m-4 9v2m7-1a7 7 0 11-14 0 7 7 0 0114 0z"
    />
  </svg>
);
